// removed by extract-text-webpack-plugin
module.exports = {"_123-wrap":"_123-wrap___hjvJV center___2iqBf","_123-flex":"_123-flex___2J6ml padding-top-12___2xTad padding-bottom-10___267DA center___2iqBf","_123-cell":"_123-cell___1Cwop","_123-image":"_123-image___cyw-6 center___2iqBf","_123-copy":"_123-copy___3cizM h3___5u0xZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OneTwoThree/OneTwoThree.css
// module id = 893
// module chunks = 0